module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.a0d768af.svg";